<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <text class="title">{{$route.meta.title}}
        <template v-if="enterFinal">
          <span style="font-weight: normal" v-if="infoDetailID">(您的展板材料和信息简表已上传)</span>
          <span style="font-weight: normal" v-else>(请尽快上传展板材料和信息简表)</span>
        </template>

      </text>
<!--      <div v-if="infoDetailID">-->
<!--        <el-button type="primary" class="ms-2 me-3"  @click="handlePreview">信息查看</el-button>-->
<!--      </div>-->
    </div>
    <div class="pub-center" v-loading="infoLoading" >
      <div class="shadow-sm bg-white px-3 py-5 " v-if="enterFinal">
      <p class="text-primary fw-bold fs-4 px-3 mt-2"> 恭喜您，您的队伍已进入决赛 ! </p>
        <p class="text-primary  fs-5 px-3 mt-2">请在 <span class="fw-bold">{{final_file_upload_start}}</span> 至 <span class="fw-bold">{{final_file_upload_end}}</span> 之间上传展板材料和信息简表</p>
        <p class="text-danger mt-2">文件命名规则：作品编号+组别(本科生组/研究生组/专科生组)+队长姓名+资料类型(展板/简表)</p>
      </div>
      <div class="shadow-sm bg-white fs-4 px-3 py-5 text-primary fw-bold" v-else>
        <p class="text-secondary fw-bold fs-4"> 暂无需上传!</p>
<!--        <p class="text-secondary fw-bold fs-5">赛事有期，创新无限——下届等你再战！</p>-->
      </div>
      <div class="shadow-sm bg-white px-3 py-2 my-2 d-flex align-items-center justify-content-center" v-if="enterFinal">
        <el-form  :loading="FinalFileLoading" :model="form" :rules="rules" size="large" label-width="auto" style="width: 100%;max-width: 1000px" ref="ruleFormRef">
          <el-row :gutter="10">
            <el-col :span="24" >
              <el-form-item label="展板材料pdf：" prop="Board">
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'Board',20,'application/pdf')"
                    :data="uploadData['Board']"
                    :on-preview="handlePreviewPdf"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept="application/pdf"
                    multiple
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      请在“参赛文件下载”中下载模板（pdf,20MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="展板材料ppt：" prop="BoardPpt">
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList3"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'BoardPpt',20,'ppt')"
                    :data="uploadData['BoardPpt']"
                    :on-preview="handlePreviewPdf"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept=".ppt,.pptx"
                    multiple
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      请在“参赛文件下载”中下载模板（ppt,20MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24" >
              <el-form-item label="信息简表：" prop="Info" >
                <el-upload
                    style="width: 400px;text-align: start"
                    v-model:file-list="fileList2"
                    :action="VUE_APP_uploadurl"
                    :before-upload="($event)=>beforeUpload($event,'Info',10,'doc')"
                    :data="uploadData['Info']"
                    :on-preview="handlePreviewPdf"
                    :on-remove="handleRemove"
                    :on-exceed="masterFileMax"
                    :on-success="handleUploadSuccess"
                    :on-error="handleUploadError"
                    :limit="1"
                    accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    multiple
                >
                  <el-button type="primary" size="middle" plain class="px-4" >上传</el-button>
                  <template #tip>
                    <div class="el-upload__tip" style="margin-top: 0">
                      请在“参赛文件下载”中下载模板（word,10MB以内）
                    </div>
                  </template>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="w-100  d-flex align-items-center justify-content-center flex-column my-4">
            <el-button type="primary" class="px-5"
                       v-loading="loading"
                       @click="save"
                       :disabled="!canupload"
            >提交
            </el-button>
            <div class="small text-secondary mt-3" v-if="canupload">可以多次提交修改信息，点击“提交”后，自动覆盖前次提交的材料。</div>
            <div class="small text-danger mt-3" v-else>当前时段无法提交</div>
          </div>
        </el-form>

      </div>
    </div>

  </div>
  <!-- 抽屉-->
<!--  <el-drawer v-model="drawer" title="已上传信息" size="100%">-->
<!--    <div class="show-detail" v-if="enterFinal">-->
<!--      <p>展板材料</p>-->
<!--      <div class="ifram-container">-->
<!--        <iframe :src="BoardUrl" width="100%" height="100%"></iframe>-->
<!--      </div>-->
<!--      <p>信息简表</p>-->
<!--      <div class="ifram-container">-->
<!--        <iframe :src="InfoUrl" width="100%" height="100%"></iframe>-->
<!--      </div>-->
<!--    </div>-->
<!--  </el-drawer>-->
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {getQiniuPrivateUploadToken} from "@/api/commonApi";
let qianniuInfo = null // 千牛上传凭证
const uploadData = reactive({"Board":{key:"",token:""},"Info":{key:"",token:""},"BoardPpt":{key:"",token:""}})
const VUE_APP_uploadurl = "https://upload-z2.qiniup.com" // 七牛地址
import {useStore} from "vuex";
import { useRouter } from "vue-router";
import {validateForm} from "@/utils/formValidate";
import {addWork, FinalFiledetail, FinalFiledNew, FinalFiledUpdate, genPreviewurl, updateWork} from "@/api/student";
const store = useStore()
const userInfo = ref({})
const loading = ref(false) // 保存信息
const infoLoading = ref(true) // 获取信息
const FinalFileLoading = ref(true) // 获取复赛文件
const incompleteInfo = ref(true)
const ruleFormRef = ref()
const enterFinal = ref(false) // 是否进入决赛
const BoardUrl = ref() // 展板信息 pdf
const InfoUrl = ref() // 信息简表
const BoardPptUrl = ref() // 展板信息 ppt
const form = reactive({
  Board:null,// string // 展板材料 文件pdf
  Info:null,// string // 信息简表 文件
  BoardPpt:null,// string // 展板材料 文件ppt
})
const final_file_upload_start = computed(()=>store.state.sysModel.final_file_upload_start)|| "" // 复赛文件提交开始时间
const final_file_upload_end = computed(()=>store.state.sysModel.final_file_upload_end) || "" // 复赛文件提交结束时间
const canupload =  computed(()=>{
  try {
   const now = new Date().getTime()
    const start = new Date(final_file_upload_start.value).getTime()
    const end = new Date(final_file_upload_end.value).getTime()
   return  start<=now && now<=end
  }catch(e){
    return false
  }
}) // 复赛文件提交开始时间
const infoDetailID = ref()
const drawer = ref(false)
const rules = ({
  Board: [
    {required: true, message: '请上传展板材料(pdf)', trigger: ['change','blur']},
  ],
  BoardPpt: [
    {required: true, message: '请上传展板材料(ppt)', trigger: ['change','blur']},
  ],
  Info: [
    {required: true, message: '请上传信息简表', trigger: ['change','blur']},
  ]
})

const fileList = ref([])
const fileList2 = ref([])
const fileList3 = ref([])
onMounted(()=>{
  getUserInfo()// 获取用户信息
  FinalFiledetailFun() // 获取当前参赛队伍的决赛信息
})


// 获取复赛文件
const FinalFiledetailFun = async ()=>{
  FinalFileLoading.value = true
  const res =await FinalFiledetail()
  FinalFileLoading.value = false
  if(res.err_code==0){ // 有数据
    const data = res.data || {}
  //  设置页面文件
    let filesName;
    if(data.Board){
      filesName = data.Board.split("/").reverse()[0]
      fileList.value = [{name:filesName,response:{key:data.Board},status:"success"}]
    }
    if(data.Info){
      filesName = data.Info.split("/").reverse()[0]
      fileList2.value = [{name:filesName,response:{key:data.Info},status:"success"}]
    }
    if(data.BoardPpt){
      filesName = data.BoardPpt.split("/").reverse()[0]
      fileList3.value = [{name:filesName,response:{key:data.BoardPpt},status:"success"}]
    }
    BoardUrl.value = data.BoardUrl
    InfoUrl.value = data.InfoUrl
    BoardPptUrl.value = data.BoardPptUrl
    infoDetailID.value = data.ID
  }else{ // 未填报数据，不做处理
    infoDetailID.value = null
  //   todo
  }
}
// 获取用户信息
const getUserInfo = async  ()=>{
  infoLoading.value = true
  await store.dispatch("loginModel/getUserInfo") //获取用户信息
  const u = store.getters["loginModel/getUserInfo"] || {}
  userInfo.value = u
  enterFinal.value = u.enterFinal
  infoLoading.value = false
}
// 上传之前判断
const beforeUpload = async(rawFile,key,limit,type)=>{
  if(!rawFile)return
  // doc 文件判断
  if(type==='doc'){ // doc
    const isWord = rawFile.type === 'application/msword' ||
        rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        rawFile.name.endsWith('.doc') ||
        rawFile.name.endsWith('.docx');

    if (!isWord) {
      ElMessage.error('只能上传 Word 文档!');
      return false;
    }
  }else if(type==='application/pdf'){ // pdf 判断
    if(rawFile.type !==type){
      ElMessage.error(`请上传指定格式的文件!`);
      return
    }
  }else if(type==='ppt'){ // ppt
    const isPPT = rawFile.name.endsWith('.ppt') || rawFile.name.endsWith('.pptx');
    if (!isPPT) {
      ElMessage.error('请上传ppt格式文件!');
      return false;
    }
  }
  const isLt = rawFile.size / 1024 / 1024 < limit;
  console.log(rawFile.size,isLt,limit)
  if (!isLt) {
    ElMessage.error(`不能大于${limit}MB!`);
    return false
  }
  // 处理文件名称
  let fileNameFull = rawFile.name,dealName;
  const files = fileNameFull.split(".") || []
  const fileType = files.splice(-1,) || []
  const fileName = files.join(".")
  if(fileName && fileType[0] ){
    dealName = fileName + "_"+new Date().getTime()+"." + fileType[0]
  }else{
    dealName = new Date().getTime()
  }
  dealName = dealName.replace(/;/g,"") // 替换掉英文的;
  let binary = new FormData()
  binary.append('file',rawFile)
  binary.append('name',rawFile.name)
  qianniuInfo = await getQiniuPrivateUploadTokenFun() // 先获取千牛上传的凭证
  if(!qianniuInfo){
    return  ElMessage.error('无法上传')
  }
  uploadData[key] = {
    key:`${qianniuInfo.filePrefix}/${dealName}`,
    token:qianniuInfo.uploadToken
  }

}
// 获取千牛上传凭证
const getQiniuPrivateUploadTokenFun =  () => {
  if(qianniuInfo && qianniuInfo.uploadToken){
    return Promise.resolve(qianniuInfo)
  }
  return getQiniuPrivateUploadToken().then(res=>{
    if(res.errCode===0){
      qianniuInfo = res
    }else{
      qianniuInfo = null
    }
    return Promise.resolve(res)
  })
}
// 文件上传
const masterFileMax = ()=>{
  ElMessage.warning("你上传的文件数量超出限制，请删除现已上传文件再上传！")
}
const handleUploadError= (err)=>{
  ElMessage.error(err.error || "上传失败")
  // console.log(999,err)
}
const handleUploadSuccess = (res)=>{

}

const handleRemove = () => {

}

// 预览pdf
const handlePreviewPdf =async (item)=>{
  let name;
  if(item.response && item.response.key){
    name = item.response.key.split("/").reverse()[0]
  }
  if(!name){
    return ElMessage.warning("无法预览")
  }else{
    const res = await genPreviewurl({filename:name})
    if(res.err_code===0 && res.data){
      const url = res.data
      window.open(url,"_blank") // 浏览器直接打开
    }else{
      return ElMessage.warning("无法预览")
    }
  }
}
const save = async ()=>{
  if(fileList.value && fileList.value.length>0){
    if(fileList.value[0].status === "success" && fileList.value[0].response){
      form.Board = fileList.value[0].response.key
    }else{
      form.Board = ""
    }
  }
  if(fileList2.value && fileList2.value.length>0){
    if(fileList2.value[0].status === "success" && fileList2.value[0].response){
      form.Info = fileList2.value[0].response.key
    }else{
      form.Info = ""
    }
  }
  if(fileList3.value && fileList3.value.length>0){
    if(fileList3.value[0].status === "success" && fileList3.value[0].response){
      form.BoardPpt = fileList3.value[0].response.key
    }else{
      form.BoardPpt = ""
    }
  }
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return ElMessage.warning("无法提交，请检查您是否有未填项")
  }
  loading.value = true

  let res,  params = {...form}
  if(infoDetailID.value){
    params.ID = infoDetailID.value
    res = await  FinalFiledUpdate(params)
  }else{
    res = await  FinalFiledNew(params)
  }
  loading.value = false
  if (res.err_code===0) {
    // ElMessage.success("保存成功")
   await FinalFiledetailFun() // 更新信息
    ElMessage.success("保存成功")
    // ElMessageBox.confirm(
    //     '可点击右上角"信息查看"按钮，查看已上传文件信息',
    //     '保存成功',
    //     {
    //   confirmButtonText: '信息查看',
    //   cancelButtonText: '关闭提醒',
    //   type: 'success',
    //   callback: (action) => {
    //     if(action==='confirm'){ // 确定
    //       handlePreview()
    //     }
    //   },
    // })
  } else {
    ElMessage.warning("保存失败")
  }
}
// 作品查看
const handlePreview = ()=>{
  drawer.value = true
}
</script>

<style scoped lang="scss">
.show-detail{
  height: 100%;
}
.ifram-container{
  width: 100%;
  height: 1400px;
  min-width: 600px;
}
</style>
